import { DataTravel, KK } from '@hid/define/define'
import { postMagnetKeyInfo } from '@libs/types/response'

export const raw = <T>(data: T): T => {
  return JSON.parse(JSON.stringify(data))
}

export function byteToBits(byte: number): number[] {
  const bits: number[] = []
  for (let i = 7; i >= 0; i--) {
    bits.push((byte >> i) & 1)
  }
  return bits
}

export function bitsToByte(bits: number[]): number {
  let byte = 0
  for (let i = 0; i < bits.length; i++) {
    byte |= 1 << i
  }
  return byte
}

export function splitIntoBytes(data: number): number[] {
  const lowByte = data & 0xff // 取低8位
  const highByte = (data >> 8) & 0xff // 取高8位
  return [lowByte, highByte]
}

export function joinBytes(bytes: number[]): number {
  const highByte = bytes[0]
  const lowByte = bytes[1]
  return (highByte << 8) | lowByte
}

export function splitDVK(num: number): [number, number] {
  if (num < 0 || num > 0xffffff) {
    throw new Error('Number must be in the range 0 to 16777215 (0xFFFFFF)')
  }

  const highByte = (num >> 16) & 0xff // 高8位
  const lowBytes = num & 0xffff // 低16位

  return [highByte, lowBytes]
}

export function enumValuesToNumberArray(enumType: any): number[] {
  return Object.keys(enumType).map((key) => enumType[key])
}

//废弃
export function makeCRC(data: number[], end: number) {
  return (0x35 + data[0] + data[1] + data[2] + end) & 0xff
}

export function extractData(data: number[][]): number[][] {
  const result: number[][] = []

  for (const segment of data) {
    for (let i = 0; i < segment.length; i++) {
      if (segment[i] === 0x07) {
        // 获取 0x07 之前的一位数据，如果没有，则填充 0
        const previousData = i > 0 ? segment[i - 1] : 0
        result.push([previousData, 0x07])
      }
    }
  }

  return result
}

// const computeSetNumberWithDeadzone = (quickTriggerReleaseNum: number, deadZone: number): number => {
//     if (quickTriggerReleaseNum == 0) return 0
//     if (quickTriggerReleaseNum < deadZone) return deadZone
//     return quickTriggerReleaseNum
// }

export const computeTravelsWithDeadzone = (data: Map<KK, DataTravel>, deadZone: number): Map<KK, DataTravel> => {
  console.log(deadZone)
  const resp = new Map<KK, DataTravel>()
  data.forEach((value, key) => {
    resp.set(key, {
      PressNum: value.PressNum,
      ReleaseNum: value.ReleaseNum,
      QuickTriggerPressNum: value.QuickTriggerPressNum,
      QuickTriggerReleaseNum: value.QuickTriggerReleaseNum,
    })
  })
  return resp
}

//data 读取的值
//set 存档的值
const computeNumberWithDeadzone2 = (data: number, set: number, dz: number): number => {
  if (data == 0 && set == 0) return 0
  if (data > dz) return data
  if (data == dz && set < dz) return set
  return data
}

//这个方法中的, oneSet.PressNum是无效代码, 需要删除
export const computeTravelsWithDeadzoneGet = (data: postMagnetKeyInfo[], set: Map<KK, DataTravel>, dz: number): postMagnetKeyInfo[] => {
  set.forEach((oneSet, key) => {
    const i = data.findIndex((item) => item.Key == key)
    if (i < 0) return
    ;(data[i].PressNum = data[i].PressNum), oneSet.PressNum
    ;(data[i].ReleaseNum = data[i].ReleaseNum), oneSet.ReleaseNum
    ;(data[i].QuickTriggerPressNum = data[i].QuickTriggerPressNum), oneSet.QuickTriggerPressNum
    data[i].QuickTriggerReleaseNum = computeNumberWithDeadzone2(data[i].QuickTriggerReleaseNum, oneSet.QuickTriggerReleaseNum, dz)
  })
  return data
}

export const computeTravelsWithDeadzoneGetForMer68SelfDev = (data: postMagnetKeyInfo[], set: Map<KK, DataTravel>, dz: number): postMagnetKeyInfo[] => {
  set.forEach((oneSet, key) => {
    const i = data.findIndex((item) => item.Key == key)
    if (i < 0) return
    data[i].PressNum = oneSet.PressNum
    data[i].ReleaseNum = oneSet.ReleaseNum
    data[i].QuickTriggerPressNum = oneSet.QuickTriggerPressNum
    data[i].QuickTriggerReleaseNum = computeNumberWithDeadzone2(data[i].QuickTriggerReleaseNum, oneSet.QuickTriggerReleaseNum, dz)
  })
  return data
}
